<section class="h-full flex flex-col gap-2 z-0 relative  p-2 lg:pl-0">

    <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
        <div class="flex flex-col sm:flex-row gap-2">
            <div class="relative">
                <input [(ngModel)]="search" type="text" (input)="onSearchInput()" required placeholder="Search.."
                    class="pl-8" />
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="absolute left-2 top-1/2 transform -translate-y-1/2 size-5">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                </svg>
            </div>
            <ng-container *ngIf="selectedTab  == 'fundingsource' || selectedTab == 'all'">
            <!-- funding source Selector -->
            <div class="w-full sm:w-44">
                <ng-select id="" class="" [(ngModel)]="selectedFundingSource" (change)="onFundingSourceChange()" [clearable]="false" [searchable]="true">
                    <ng-option value="">Select FS</ng-option>
                    <ng-option *ngFor="let fundingsource of fundingSourceList" [value]="fundingsource.id">{{
                        fundingsource.title | titlecase }}</ng-option>
                </ng-select>
            </div>
            </ng-container>

            <ng-container *ngIf="selectedTab  == 'company' || selectedTab == 'all'">
            <!-- company Selector -->
            <div class="w-full sm:w-44">
                <ng-select id="" class="" [(ngModel)]="selectedCompany" (change)="onCompanyChange()" [clearable]="false">
                    <ng-option value="">Select Company</ng-option>
                    <ng-option *ngFor="let company of companies" value="{{company.id}}">{{ company.name | titlecase }}
                    </ng-option>
                </ng-select>
            </div>
            </ng-container>

            <div>
                <select class="w-full sm:w-40" [(ngModel)]="selectedStatus" (change)="onSelectStatus()"
                    id="inputStatus">
                    <option [ngValue]="true">Active</option>
                    <option [ngValue]="false">Inactive</option>
                </select>
            </div>
        </div>
        <div *ngIf="filteredUsersList && filteredUsersList.length">
            <h1 class="text-xs text-nowrap text-left">
                Showing {{(50 * currentPage) - (filteredUsersList.length != 50?
                (50
                -filteredUsersList.length) : 0) }} of {{totalResults }} entries
                <!-- Showing {{ filteredUsersList.length }} of {{ filteredUsersList.length }} entries -->
            </h1>
        </div>

        <div>
            <button routerLink="add" *ngIf="permissionService.hasPermission([userPermission.MANAGE_USERS])"
                class="btn btn-secondary">
                Add
            </button>
        </div>

    </div>

    <div class="flex justify-end lg:pr-2 lg:pl-0">
        <div
            class="inline-flex flex-wrap p-1 rounded-lg gap-0.5 bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg focus:outline-none">

            <!-- All Tab -->
            <!-- <div (click)="applyFilter('all')"
                [ngClass]="selectedTab === 'all' ? 'btn btn-secondary sm:text-xs/5' : 'btn-outline dark:hover:bg-zinc-700/20 border-transparent btn-outline-secondary sm:text-xs/5'"
                class="cursor-pointer">
                All
            </div> -->

            <!-- Dynamic Tabs -->
            <div *ngFor="let type of types" (click)="applyFilter(type)"
                [ngClass]="selectedTab === type ? 'btn btn-secondary sm:text-xs/5' : 'btn-outline dark:hover:bg-zinc-700/20 border-transparent btn-outline-secondary sm:text-xs/5'"
                class="cursor-pointer">
                {{type | titlecase}}
            </div>

        </div>
    </div>


    <div
        class="h-full overflow-hidden p-2 flex flex-col rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10">
        <div class="h-full w-full overflow-hidden rounded-md ring-1 ring-zinc-950/10 dark:ring-white/10">
            <div class="flow-root h-full overflow-y-auto">
                <div class="-my-2">
                    <div class="inline-block min-w-full py-2 align-middle">
                        <table class="min-w-full border-separate border-spacing-0">
                            <thead>
                                <tr>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        #
                                    </th>
                                    <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap"
                                        *ngIf="permissionService.hasPermission([userPermission.MANAGE_USERS])">
                                        Action
                                    </th>

                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Name</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Email
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm text-gray-900 dark:text-gray-100 border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <span class="flex justify-start items-start">
                                            Association
                                            <div class="relative inline-block text-left">
                                                <div class="mr-2 cursor-pointer" (click)="openCloseInfo()">
                                                    <span>
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                                                            viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                                                            class="w-5 h-5 text-gray-500 dark:text-gray-300">
                                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                                d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" />
                                                        </svg>
                                                    </span>
                                                </div>

                                                <div *ngIf="isInfo"
                                                    class="p-2 absolute z-50 right-0 mt-2 w-56 origin-top-right rounded-md bg-white dark:bg-zinc-950 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none h-fit border border-main-base dark:border-zinc-700">

                                                    <h3
                                                        class="font-medium text-sm text-gray-800 dark:text-gray-200 flex space-x-2">
                                                        <span>Info</span>
                                                    </h3>

                                                    <dl
                                                        class="mt-2 divide-y divide-main-base dark:divide-zinc-600 border-t border-main-base dark:border-zinc-700">
                                                        <div
                                                            class="flex justify-between items-center py-3 text-xs font-medium">
                                                            <dt class="badge badge-secondary text-xs">FS</dt>
                                                            <dd class="text-gray-700 dark:text-gray-300">Funding
                                                                Source</dd>
                                                        </div>
                                                        <div
                                                            class="flex justify-between items-center py-3 text-xs font-medium">
                                                            <dt class="badge badge-warning text-xs">M</dt>
                                                            <dd class="text-gray-700 dark:text-gray-300">Member</dd>
                                                        </div>
                                                        <div
                                                            class="flex justify-between items-center pt-3 text-xs font-medium">
                                                            <dt class="badge badge-success text-xs">C</dt>
                                                            <dd class="text-gray-700 dark:text-gray-300">Company
                                                            </dd>
                                                        </div>
                                                    </dl>

                                                </div>
                                            </div>
                                        </span>
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Role
                                    </th>

                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Status
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="hover:bg-gray-950/5 dark:hover:bg-white/10"
                                    *ngFor="let user of (filteredUsersList | paginate: { itemsPerPage:numberOfRecords, currentPage: currentPage, totalItems:totalResults}); let i=index">
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{i+1}}
                                    </td>
                                    <td *ngIf="permissionService.hasPermission([userPermission.MANAGE_USERS])"
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <div class="flex">
                                            <button [appToolTip]="'Edit'" (click)="openUsereModal(user)"
                                                class="hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400">
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                    stroke-width="1.5" stroke="currentColor" class="size-5">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                                                </svg>
                                            </button>
                                        </div>
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{(user.name | titlecase) || 'N/A'}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{user.email || 'N/A'}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <ng-container *ngIf="
                                                  (user.company) ||
                                                  (user.fundingsource) ||
                                                  (user.member); 
                                                  else elseBlock">
                                            <span *ngIf="user.company">
                                                {{ (user.company?.name) | titlecase }}
                                                <span class="badge badge-success text-xs">
                                                    C
                                                </span>
                                            </span>

                                            <span *ngIf="user.fundingsource">
                                                {{ (user.fundingsource?.title) | titlecase }}
                                                <span class="badge badge-secondary text-xs">
                                                    FS
                                                </span>
                                            </span>
                                            <span *ngIf="user.member">
                                                {{ (user.member?.displayName) | titlecase }}
                                                <span class="badge badge-warning text-xs">
                                                    M
                                                </span>
                                            </span>
                                        </ng-container>

                                        <ng-template #elseBlock>
                                            N/A
                                        </ng-template>
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <span *ngIf="user.role && user.role.type && user.role.name">
                                            <span class="text-zinc-600 dark:text-white">{{ user.role.type |
                                                titlecase }}</span>
                                            <span> ({{ (user.role.name | titlecase) || 'N/A' }})</span>
                                        </span>
                                    </td>

                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <span [ngClass]="user.isActive ? 'badge-success':'badge-danger'">{{user.isActive
                                            ? 'Active' :
                                            'Inactive'}}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex justify-end">
            <pagination-controls (pageChange)="onPageChange($event)" class="pagination-controls"></pagination-controls>
        </div>
    </div>

</section>

<!-- <app-funding-source-edit-modal
  *ngIf="userModalObj"
  [user]="userModalObj"
  (onCloseModal)="onCloseUserModal()"
></app-funding-source-edit-modal> -->
<!-- (onSave)="onSaveFundingSource($event)" -->

<app-users-edit-modal *ngIf="userModalObj" [user]="userModalObj" (onCloseModal)="onCloseUserModal()"
    (onSaveUser)="onSave($event)">
</app-users-edit-modal>